import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { TabReqModel, TabRespModel } from '../shared/models/formly-custom';

@Injectable({
  providedIn: 'root',
})
export class FormFieldsService {
  private fieldUpdate = new Subject<{ key: string; value: any }>();
  activeTabIndex = 0;
  removedTabIndex: number = 0;
  fieldUpdate$ = this.fieldUpdate.asObservable();
  tabOperationReq = signal<TabReqModel>(undefined);
  tabOperationResp = signal<TabRespModel>(undefined);
  isCollectionOpPending = signal<boolean>(false);

  trackField(field: { key: string; value: any }): void {
    this.fieldUpdate.next(field);
  }
}
